import React, { Fragment, useState, useEffect } from "react";
import TransactionTable from '../components/TransactionTable';
import Accounts from '../components/Accounts'
import NetWorth from '../components/NetWorth'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Title from './Title';
import Budget from "./Budget";

const styles = theme => ({
  controlSection: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
  },
  radioGroup: {
    //marginBottom: theme.spacing(2),
  },
  dateInput: {
    width: '150px',
    marginRight: theme.spacing(2),
  },
  yearSelect: {
    minWidth: 120,
    marginLeft: theme.spacing(2),
  },
  customRangeContainer: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
});

const PeriodSummary = (props) => {
    const { space_id } = props.match ? props.match.params : { space_id: null };
    const { classes } = props;

    const [dateRangeType, setDateRangeType] = useState('ytd');
    const [selectedYear, setSelectedYear] = useState(moment().year()-1);
    const [startDate, setStartDate] = useState(new Date(moment().startOf('year')));
    const [endDate, setEndDate] = useState(new Date(moment()));
    const [calculatedStartDate, setCalculatedStartDate] = useState(moment().startOf('year'));
    const [calculatedEndDate, setCalculatedEndDate] = useState(moment());

    // Generate year options (current year and past 10 years)
    const currentYear = moment().year();
    const yearOptions = [];
    for (let i = 1; i <= 1; i++) {
        yearOptions.push(currentYear - i);
    }


    // Calculate start and end dates based on selected type
    useEffect(() => {
        let start, end;

        if (dateRangeType === 'ytd') {
            // Year To Date: from January 1st of current year to today
            start = moment().startOf('year');
            end = moment();
        } else if (dateRangeType === 'calendar') {
            // Calendar Year: from January 1st to December 31st of selected year
            start = moment().year(selectedYear).startOf('year');
            end = moment().year(selectedYear).endOf('year');
        } else if (dateRangeType === 'custom') {
            // Custom Range: use selected dates
            start = moment(startDate);
            end = moment(endDate);
        }

        setCalculatedStartDate(start);
        setCalculatedEndDate(end);
    }, [dateRangeType, selectedYear, startDate, endDate]);

    const handleDateRangeTypeChange = (event) => {
        setDateRangeType(event.target.value);
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    return (
        <div>
            {space_id &&
                <Fragment>
                    <Paper className={classes.controlSection}>
                        <Title>Period Summary</Title>
                        <FormControl component="fieldset">
                            <RadioGroup
                                className={classes.radioGroup}
                                row
                                value={dateRangeType}
                                onChange={handleDateRangeTypeChange}
                            >
                                <FormControlLabel value="ytd" control={<Radio />} label="Year To Date" />
                                <FormControlLabel value="calendar" control={<Radio />} label="Calendar Year" />
                                <FormControlLabel value="custom" control={<Radio />} label="Custom Range" />
                            </RadioGroup>
                        </FormControl>

                        {dateRangeType === 'calendar' && (
                            <FormControl className={classes.yearSelect}>
                                <InputLabel>Year</InputLabel>
                                <Select
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                >
                                    {yearOptions.map(year => (
                                        <MenuItem key={year} value={year}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}

                        {dateRangeType === 'custom' && (
                            <div className={classes.customRangeContainer}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        className={classes.dateInput}
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        margin="normal"
                                        id="start-date"
                                        label="Start Date"
                                        value={startDate}
                                        onChange={handleStartDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change start date',
                                        }}
                                    />
                                    <KeyboardDatePicker
                                        disableToolbar
                                        className={classes.dateInput}
                                        variant="inline"
                                        format="MM/dd/yyyy"
                                        margin="normal"
                                        id="end-date"
                                        label="End Date"
                                        value={endDate}
                                        onChange={handleEndDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change end date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        )}
                    </Paper>
                    <NetWorth space_id={space_id} startDate={calculatedStartDate} endDate={calculatedEndDate} initialGroupByCategory={true} />
                    {/* <NetWorthTimeChart space_id={space_id} fixedStartDate={calculatedStartDate} fixedEndDate={calculatedEndDate} /> */}
                    <Budget space_id={space_id} startDate={calculatedStartDate} endDate={calculatedEndDate} totalsOnly={true} />
                </Fragment>
            }
        </div>
    )
}



export default withStyles(styles)(PeriodSummary);